"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _api = require("./api");

var _default = function _default(_ref) {
  var type = _ref.type,
      path = _ref.path,
      userId = _ref.userId,
      _ref$sqon = _ref.sqon,
      sqon = _ref$sqon === void 0 ? {} : _ref$sqon,
      _ref$returnIds = _ref.returnIds,
      returnIds = _ref$returnIds === void 0 ? false : _ref$returnIds,
      api = _ref.api,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? [] : _ref$sort;
  return (api || _api.graphql)({
    query: "\n      mutation saveSet($type: String! $userId: String $sqon: JSON! $path: String!, $sort: [Sort]) {\n        saveSet(type: $type, userId: $userId, sqon: $sqon, path: $path, sort: $sort) {\n          setId\n          createdAt\n          path\n          size\n          sqon\n          type\n          userId\n          ".concat(returnIds ? "ids" : "", "\n        }\n      }\n    "),
    variables: {
      sqon: sqon,
      type: type,
      userId: userId,
      path: path,
      sort: sort
    }
  });
};

exports["default"] = _default;